import { PALETTE, WHEN_MD } from "../constants";

import BaseHeading from "./SectionHeading";
import ContentContainer from "./ContentContainer";
import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";

const OuterContainer = styled(ContentContainer)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${PALETTE.PRIMARY["100"]};

  flex-direction: column;
  ${WHEN_MD} {
    flex-direction: row;
  }
`;

const InnerLeftContainer = styled.div`
  max-width: 600px;
  flex: 1;
  padding-right: 0;
  margin-bottom: 2rem;
  text-align: center;

  ${WHEN_MD} {
    text-align: left;
    padding-right: 4rem;
    margin-bottom: 0;
  }

  button {
    margin: auto;
    ${WHEN_MD} {
      margin: 0;
    }
  }
`;
const InnerRightContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 400px;
`;

const Heading = styled(BaseHeading)`
  margin: auto;
  margin-bottom: 0.5rem;

  ${WHEN_MD} {
    margin: 0 0 0.5rem;
  }
`;
export default function GettingSetup() {
  return (
    <OuterContainer>
      <InnerLeftContainer>
        <Heading>Ready to Get Started?</Heading>
        <StaticImage
          src="../images/our-story-stroke-1.svg"
          alt="stroke"
          placeholder="blurred"
          objectFit="contain"
          width={250}
          height={15}
        />
        <p className="text-md mt-2 u-text-left">
          Once you create an account, our interactive dashboard will walk you
          through the setup process.
        </p>
        <p className="text-md u-text-left">
          After your initial setup, you can revisit this dashboard at any time
          to tweak your preferences and get realtime status updates on your
          transaction data and account balances
        </p>
        <button
          onClick={() => {
            window.open("https://app.nofi.so", "_blank");
          }}
          className="btn btn-primary btn--lg hide-md-block"
        >
          Sign Up
        </button>
        <button
          onClick={() => window.open("https://app.nofi.so", "_blank")}
          className="btn btn-primary btn--md sm-only-block"
        >
          Sign Up
        </button>
      </InnerLeftContainer>
      <InnerRightContainer>
        <ImageContainer>
          <StaticImage
            src="../images/getting-setup-plaid-modal.gif"
            alt="getting setup"
            placeholder="blurred"
            objectFit="contain"
            style={{ width: "100%", height: "100%" }}
          />
        </ImageContainer>
      </InnerRightContainer>
    </OuterContainer>
  );
}
